export { default } from './TemplateChangesSubtitle';
